const token = (data) => data?.token;

const getQuoteLoginFlowReaders = {
  token  
};

export default getQuoteLoginFlowReaders;
